import "../../styles/AdminDashboard.css";

function PageTitle() {
  return (
    <div className="adminDash__pageHeader">
      <h1 className="adminDash__pageTitle">Dashboard</h1>
      <p className="adminDash__pageSubtitle">
        Monitor registrations, manage datasets, and oversee platform activity across Kaduna and Kano
        states.
      </p>
    </div>
  );
}

export default PageTitle;
